'use strict';

function createQueuedBatches(batches) {
  return (Array.isArray(batches) ? batches : []).map((batch, index) => ({
    ...batch,
    status: index === 0 ? 'active' : 'pending'
  }));
}

function getNextPendingBatch(batches, activeBatchId) {
  const queue = Array.isArray(batches) ? batches : [];
  const activeIndex = queue.findIndex(batch => batch?.id === activeBatchId);
  if (activeIndex < 0) return null;
  return queue.slice(activeIndex + 1).find(batch => batch?.status === 'pending') || null;
}

function getBatchById(batches, batchId) {
  return (Array.isArray(batches) ? batches : []).find(batch => batch?.id === batchId) || null;
}

function getPreviewFallbackBatch(batches, removedBatchIndex) {
  const queue = Array.isArray(batches) ? batches : [];
  if (queue.length === 0) return null;
  const fallbackIndex = Math.min(Math.max(removedBatchIndex, 0), queue.length - 1);
  return queue[fallbackIndex];
}

function updateBatchById(batches, batchId, updates) {
  return (Array.isArray(batches) ? batches : []).map(batch =>
    batch?.id === batchId ? { ...batch, ...updates } : batch
  );
}

function completeAndActivateNextBatch(batches, completedBatchId) {
  const nextBatch = getNextPendingBatch(batches, completedBatchId);
  const nextBatches = (Array.isArray(batches) ? batches : []).map(batch => {
    if (batch?.id === completedBatchId) return { ...batch, status: 'completed' };
    if (batch?.id === nextBatch?.id) return { ...batch, status: 'active' };
    return batch;
  });

  return { batches: nextBatches, nextBatch };
}

function removeQueuedBatches(batches, batchIds, { isPublishing = false } = {}) {
  const idsToRemove = new Set(Array.isArray(batchIds) ? batchIds : [batchIds]);
  const remaining = (Array.isArray(batches) ? batches : []).filter(batch => {
    if (!idsToRemove.has(batch?.id)) return true;
    return isPublishing && batch?.status === 'active';
  });

  if (!remaining.some(batch => batch?.status === 'active')) {
    const nextPendingIndex = remaining.findIndex(batch => batch?.status === 'pending');
    if (nextPendingIndex >= 0) {
      return remaining.map((batch, index) => index === nextPendingIndex ? { ...batch, status: 'active' } : batch);
    }
  }

  return remaining;
}

module.exports = {
  createQueuedBatches,
  getBatchById,
  getPreviewFallbackBatch,
  updateBatchById,
  getNextPendingBatch,
  completeAndActivateNextBatch,
  removeQueuedBatches
};